import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
//import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
//import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";
import secure from "../../Assets/Projects/secure.png";
import waste from "../../Assets/Projects/weste1.png";
import calculator from "../../Assets/Projects/calculator.png";
import student from "../../Assets/Projects/student1.png";
import ebs from "../../Assets/Projects/EBS.png";
import costAwsOptimize from "../../Assets/Projects/costAwsOptimize.png";
import dockerSecurity from "../../Assets/Projects/dockerSecurity.png";
import tf3 from "../../Assets/Projects/tf3.png";


function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={costAwsOptimize}
              isBlog={false}
              title="AWS Cost Optimization Dashboard"
              description="Built a comprehensive AWS cost optimization dashboard using Python and boto3 that analyzes resource utilization patterns and provides actionable insights for reducing cloud expenses. The tool identifies underutilized resources, recommends rightsizing opportunities, and automates cost-saving measures across multiple AWS services, resulting in up to 30% cost reduction for enterprise clients."
              ghLink="https://github.com/sourav8908/aws-cost-optimization-tool"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={tf3}
              isBlog={false}
              title="Terraform Drift Detection & Remediation Tool for AWS"
              description="Terraform Drift Detection Tool is a Python-based DevOps automation project that detects configuration drift between Terraform state files and live AWS infrastructure. It identifies manual changes made outside Terraform, classifies drift by severity, and generates clear HTML reports for analysis. The tool also auto-generates Terraform HCL code to help remediate drift and restore infrastructure consistency. It supports multiple AWS regions and profiles and integrates with CI/CD pipelines like GitHub Actions, Jenkins, GitLab CI, and CircleCI for automated drift detection. This project helps enforce Infrastructure as Code best practices and improves cloud infrastructure reliability."
              ghLink="https://github.com/sourav8908/terraform-drift-detector.git"
            />
          </Col>
          
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={dockerSecurity}
              isBlog={false}
              title="Docker Security Automation Tool"
              description="Engineered a comprehensive Docker security automation tool that performs vulnerability scanning, configuration auditing, and compliance checking for containerized applications. Built with Python and Docker SDK, the tool integrates seamlessly into CI/CD pipelines to ensure security best practices are maintained throughout the development lifecycle, significantly reducing security risks in production environments."
              ghLink="https://github.com/sourav8908/docker-security-scanner"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ebs}
              isBlog={false}
              title="EBS Snapshot Cost Optimizer"
              description="I built a serverless AWS Lambda function in Python to automatically detect and delete stale EBS snapshots that are no longer associated with any active or stopped EC2 instances. This solution helps reduce unnecessary AWS storage costs and improves resource hygiene. It leverages the AWS SDK (boto3) and follows security best practices using least-privilege IAM roles. The function is fully monitored through AWS CloudWatch, providing clear insights into each execution. This automation ensures efficient storage management with minimal manual effort."
              ghLink="https://github.com/sourav8908/ebs-snapshot-cost-optimizer"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={secure}
              isBlog={false}
              title="Secure File Sharing Platform"
              description="Developed a secure file sharing web application using Java EE (Servlets, JSP, JDBC) and MySQL, featuring password protection, time-limited access, and role-based file permissions. Integrated BCrypt hashing, session management, and authentication filters for robust security. Containerized with Docker and Docker Compose, and deployed on AWS EC2 with automated CI/CD pipelines via Jenkins for streamlined development and deployment."
              ghLink="https://github.com/sourav8908/Secure_File_Share"
              //demoLink="https://plant49-ai.herokuapp.com/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={waste}
              isBlog={false}
              title="Smart City Waste Management Portal"
              description="Engineered a full-stack web application for urban waste reporting and tracking using Java, Node.js, Express, MySQL, and RESTful APIs. Enabled residents to report local issues in real time. Containerized with Docker and Docker Compose for consistent multi-container environments. Automated CI/CD workflows with Jenkins, integrating GitHub, Docker Hub, and AWS EC2. Deployed on EC2 with secure configurations, implementing SSH access, user authentication, role-based access control, and robust error handling for a secure and reliable system.."
              ghLink="https://github.com/sourav8908/City-Waste-Management-System"
              //demoLink="https://plant49-ai.herokuapp.com/"
            />
          </Col>
           <Col md={4} className="project-card">
            <ProjectCard
              imgPath={calculator}
              isBlog={false}
              title="Advanced Calculator with Tags and History"
              description="Advanced Calculator with Tags and History is a full-stack web application that combines standard and scientific calculator features within a clean, responsive interface. Built using Java ,HTML5, CSS3, JavaScript (ES6+), Node.js, Express.js, and MySQL, it supports a wide range of operations—from basic arithmetic to advanced functions like trigonometry and logarithms. A key feature is its tag-based system, allowing users to organize calculations (e.g., Food, Shopping) for easy filtering and retrieval. The app also maintains a persistent, searchable history with options to edit, delete, and filter by date or tag. The RESTful backend ensures robust performance and data management, highlighting my skills in building user-friendly, well-structured web applications.."
              ghLink="https://github.com/sourav8908/Advanced-Calculator"
              //demoLink="https://plant49-ai.herokuapp.com/"
            />
          </Col>
           <Col md={4} className="project-card">
            <ProjectCard
              imgPath={student}
              isBlog={false}
              title="Student Attendance System using QR Codes"
              description="This project automates student attendance management by leveraging QR code technology. Administrators can manage batches, students, and subjects, while students mark their attendance by scanning session-specific QR codes. The system streamlines attendance tracking, reduces manual errors, and enhances security and efficiency in educational environments."
              ghLink="https://github.com/sourav8908/Attendance_System"
              //demoLink="https://plant49-ai.herokuapp.com/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Chatify"
              description="The Assistant UI + Gemini Starter is a ready-to-use AI-powered chat assistant that leverages the Assistant UI framework and integrates with Google Gemini 2.0 through the @ai-sdk/google. Built on Next.js 15 and powered by Turbopack, this project provides a seamless setup for creating AI-driven chat applications."
              ghLink="https://github.com/sourav8908/assistant-ui-gemini-chat"
              //demoLink="https://chatify-49.web.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Bits-0f-C0de"
              description="My personal blog page build with Next.js and Tailwind Css which takes the content from makdown files and renders it using Next.js. Supports dark mode and easy to write blogs using markdown."
              ghLink="https://github.com/soumyajit4419/Bits-0f-C0de"
              //demoLink="https://blogs.soumya-jit.tech/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Editor.io"
              description="Online code and markdown editor build with react.js. Online Editor which supports html, css, and js code with instant view of website. Online markdown editor for building README file which supports GFM, Custom Html tags with toolbar and instant preview.Both the editor supports auto save of work using Local Storage"
              ghLink="https://github.com/soumyajit4419/Editor.io"
             // demoLink="https://editor.soumya-jit.tech/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="Plant AI"
              description="Used the plant disease dataset from Kaggle and trained a image classifer model using 'PyTorch' framework using CNN and Transfer Learning with 38 classes of various plant leaves. The model was successfully able to detect diseased and healthy leaves of 14 unique plants. I was able to achieve an accuracy of 98% by using Resnet34 pretrained model."
              ghLink="https://github.com/soumyajit4419/Plant_AI"
              //demoLink="https://plant49-ai.herokuapp.com/"
            />
          </Col>

          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Ai For Social Good"
              description="Using 'Natural Launguage Processing' for the detection of suicide-related posts and user's suicide ideation in cyberspace  and thus helping in sucide prevention."
              ghLink="https://github.com/soumyajit4419/AI_For_Social_Good"
              // demoLink="https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley" <--------Please include a demo link here
            />
          </Col> */}

          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Face Recognition and Emotion Detection"
              description="Trained a CNN classifier using 'FER-2013 dataset' with Keras and tensorflow backened. The classifier sucessfully predicted the various types of emotions of human. And the highest accuracy obtained with the model was 60.1%.
              Then used Open-CV to detect the face in an image and then pass the face to the classifer to predict the emotion of a person."
              ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
              // demoLink="https://blogs.soumya-jit.tech/"      <--------Please include a demo link here 
            />
          </Col> */}
          
          
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
